import { makeAutoObservable } from 'mobx'

export const SNACKBAR_DURATION = 2000

export const snackbarStore = makeAutoObservable(
    {
        content: '',

        visible: false,

        show(content: string, name: string, duration = SNACKBAR_DURATION) {
            this.visible = true
            this.content = content
            setTimeout(this.hide, duration)
        },

        hide() {
            this.visible = false
        },
    },
    {},
    { autoBind: true },
)
